import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { postRequest } from 'utils/api';
import { follow, unfollow } from 'features/profilesSlice';
import FollowIcon from 'components/FollowIcon';

const FollowProfile = ({ profile, circleHeart }) => {
  const dispatch = useDispatch();
  const followingIds = useSelector(state => state.profiles.followingIds);

  const handleFollow = () => {
    postRequest({ endpoint: `profiles/${profile.id}/follow` }).then(() => {
      dispatch(follow(profile.id));
    });
  };

  const handleUnfollow = () => {
    postRequest({ endpoint: `profiles/${profile.id}/unfollow` }).then(() => {
      dispatch(unfollow(profile.id));
    });
  };

  return (
    <FollowIcon
      following={followingIds.includes(profile.id)}
      handleFollow={handleFollow}
      handleUnfollow={handleUnfollow}
      circleHeart={circleHeart}
    />
  );
};

FollowProfile.propTypes = {
  profile: PropTypes.object.isRequired,
  setProfile: PropTypes.func.isRequired,
  circleHeart: PropTypes.bool,
};

FollowProfile.defaultProps = {
  circleHeart: false,
};

export default FollowProfile;
